// extracted by mini-css-extract-plugin
export var borderTop = "_g-3";
export var linkIcon = "_g-5";
export var linkIconSm = "_g-6";
export var linkOutCard = "_g-7 _g-4";
export var linkRow = "_g-2";
export var pageContainer = "_g-1";
export var providerIcon = "_g-8";
export var roundedBorder = "_g-4";
export var settingsContent = "_g-0";